import { render, staticRenderFns } from "./SettingsItem.vue?vue&type=template&id=2b5574bc&scoped=true"
import script from "./SettingsItem.vue?vue&type=script&lang=js"
export * from "./SettingsItem.vue?vue&type=script&lang=js"
import style0 from "./SettingsItem.vue?vue&type=style&index=0&id=2b5574bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5574bc",
  null
  
)

export default component.exports